export const ServiceHost = 'https://service.copmbak.xyz/api'